import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum';
import type { App, Plugin } from 'vue';
import { DatadogService } from './datadog.service';

export const DATADOG_SERVICE = Symbol('DATADOG_SERVICE');

export function createDatadog(configuration: RumInitConfiguration): Plugin {
  return {
    install(app: App) {
      datadogRum.init(configuration);
      app.provide(DATADOG_SERVICE, new DatadogService(datadogRum));
    },
  };
}
